// hls.js (and Plyr, when a standard player is on the page) are loaded as WordPress
// script dependencies before this bundle
require("./VideoLoader");
require("./heroSectionVideo");
const MinimalPlayer = require("./MinimalPlayer");

class MadVideo {
  /**
   * Konstruktor der MadVideo Klasse.
   * @param {jQuery} $container - Das jQuery-Element des Video-Containers.
   */
  constructor($container) {
    this.$container = $container;
    this.videoUrl = this.$container.data("video-url");
    this.autoplay = this.$container.data("video-autoplay") === true;
    this.customThumbnail = this.$container.data("video-thumbnail");
    this.provider = this.$container.data('video-provider') || null;
    this.videoId = this.$container.data('video-id') || null;
    const volAttr = this.$container.data('default-volume'); // "0"…"100" or undefined
    this.defaultVolume = volAttr !== undefined ? parseFloat(volAttr) / 100 : 0.5; // 0–1
    this.aspectRatio = this.$container.attr('data-aspect-ratio') || null; // e.g. "9:16"
    this.showOverlay = this.$container.data('overlay') !== false; // no attribute → overlay
    this.playerConfig = this.$container.data('player-config') || null; // {controls, settings, behavior}

    // Definieren der jQuery-Elemente als Klassenattribute
    this.$overlay = this.$container.find(".mad-video__overlay");
    this.$playButton = this.$container.find(".mad-video__play-button");
    this.$videoContainer = this.$container.find(".mad-video");
    this.isPlaying = false;
    this.isVideoConsentGiven = false;

    this.init();
  }

  /**
   * Initialisierung der Video-Container.
   * Setzt Event-Listener, behandelt die Zustimmung und lädt das Thumbnail.
   */
  init() {
    // No overlay: show the player right away (poster + Plyr play button)
    if (!this.showOverlay) {
      this.initPlayerWithoutOverlay();
      return;
    }

    const type = this.getVideoTypeFromUrl();

    this.isVideoConsentGiven = true;//this.isLocalDomainVideo(this.videoUrl) || type === "hls";

    jQuery(document).on(`madVideoConsentGiven:${type}`, (event, data) => {
      this.isVideoConsentGiven = true;
      this.playVideo();
    });

    if (window.madVideoConsentGiven && window.madVideoConsentGiven[type]) {
      this.isVideoConsentGiven = true;
    }

    // Event-Listener for the Play-Button
    this.$playButton.on("click", (e) => {
      e.preventDefault();
      if (!this.isVideoConsentGiven) {
        jQuery(document).trigger("madRequestVideoConsent", { type: type });
        this.isVideoConsentGiven = true;
      }
      this.playVideo(true);
    });

    // Autoplay if consent is already given and autoplay is enabled
    if (this.isVideoConsentGiven && this.autoplay && !this.isPlaying) {
      this.playVideo();
    }

    // Thumbnail laden und anzeigen
    this.loadThumbnail();
  }

  /**
   * Checks if a video URL is from the same domain or subdomain as the current page.
   * @param {string} url - The video URL to check.
   * @returns {boolean} - True if the video is from the same domain or subdomain.
   */
  isLocalDomainVideo(url) {
    try {
      if (!url) return false;

      if (url.startsWith('/')) {
        return true;
      }

      const siteDomain = window.location.hostname;

      const videoUrlObj = new URL(url);
      const videoDomain = videoUrlObj.hostname;

      if (videoDomain === siteDomain) {
        return true;
      }

      const mainDomainParts = siteDomain.split('.');
      const mainDomain = mainDomainParts.slice(mainDomainParts.length - 2).join('.');

      return videoDomain.endsWith('.' + mainDomain);
    } catch (e) {
      console.error('Error checking domain:', e);
      return false;
    }
  }

  /**
   * Determines the video type based on the video URL.
   * @returns {string} One of: 'youtube', 'vimeo', 'hls', 'default'
   */
  getVideoTypeFromUrl() {
    if (this.provider) return this.provider;
    if (this.extractVimeoId(this.videoUrl)) return 'vimeo';
    if (this.extractYoutubeId(this.videoUrl)) return 'youtube';
    if (this.isHlsUrl(this.videoUrl)) return 'hls';
    return 'default';
  }


  /**
   * Ruft das Thumbnail eines Vimeo-Videos anhand seiner ID ab.
   * @param {number|string} videoId - Die ID des Vimeo-Videos.
   * @returns {Promise<string>} - Ein Promise, das die Thumbnail-URL zurückgibt.
   */
  async fetchVimeoThumbnail(videoId) {
    const url = `https://vimeo.com/api/v2/video/${videoId}.json`;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Netzwerkantwort war nicht ok: ${response.statusText}`);
      }

      const data = await response.json();

      if (data && data.length > 0 && data[0].thumbnail_large) {
        return data[0].thumbnail_large;
      } else {
        throw new Error("Thumbnail nicht gefunden.");
      }
    } catch (error) {
      console.error("Fehler beim Abrufen des Thumbnails:", error);
      throw error;
    }
  }

  /**
   * Lädt das Thumbnail für das Video.
   * Unterstützt Vimeo, YouTube. Lädt nur, wenn Zustimmung gegeben wurde für externe Quellen.
   */
  async loadThumbnail() {
    const type = this.getVideoTypeFromUrl();

    // Use custom thumbnail if provided
    if (this.customThumbnail) {
      this.$overlay.css("background-image", `url(${this.customThumbnail})`);
      return;
    }

    if (type === 'default') return;

    // Only load external thumbnails if consent is given
    if (this.isVideoConsentGiven || this.isLocalDomainVideo(this.videoUrl)) {
      const vimeoId = this.extractVimeoId(this.videoUrl);
      const youtubeId = this.extractYoutubeId(this.videoUrl);

      if (vimeoId && type === 'vimeo') {
        try {
          const thumbnailUrl = await this.fetchVimeoThumbnail(vimeoId);
          this.$overlay.css("background-image", `url(${thumbnailUrl})`);
        } catch (error) {
          console.error("Fehler beim Laden des Vimeo-Thumbnails:", error);
        }
      } else if (youtubeId && type === 'youtube') {
        const thumbnailUrl = `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;
        this.$overlay.css("background-image", `url(${thumbnailUrl})`);
      } else if (type === 'hls') {
        // Custom thumbnail for HLS needed
      }
    }
  }

  /**
   * Extrahiert die Vimeo ID aus der Video-URL.
   * @param {string} url - Die URL des Vimeo-Videos.
   * @returns {string|null} - Die extrahierte Vimeo ID oder null, wenn nicht gefunden.
   */
  extractVimeoId(url) {
    const vimeoRegex =
      /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
    const match = url.match(vimeoRegex);
    return match ? match[1] : null;
  }

  /**
   * Extrahiert die YouTube ID aus der Video-URL.
   * @param {string} url - Die URL des YouTube-Videos.
   * @returns {string|null} - Die extrahierte YouTube ID oder null, wenn nicht gefunden.
   */
  extractYoutubeId(url) {
    if (!url) return null;
    const youtubeRegex =
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = url.match(youtubeRegex);
    return match ? match[1] : null;
  }

  /**
   * Checks if the URL is an HLS stream URL.
   * @param {string} url - The URL to check.
   * @returns {boolean} - True if the URL is an HLS stream, false otherwise.
   */
  isHlsUrl(url) {
    if (!url) return false;
    return /\.m3u8$/i.test(url);
  }

  /**
   * Methode zum Abspielen des Videos.
   * Versteckt das Overlay und nutzt VideoLoader zum Laden des Videos.
   */
  playVideo(fromClick = false) {
    if (this.isPlaying) return;

    if (!this.isVideoConsentGiven) {
      const type = this.getVideoTypeFromUrl();
      jQuery(document).trigger("madRequestVideoConsent", { type: type });
      return;
    }

    this.isPlaying = true;

    // Minimal player: start synchronously inside the click, so browsers (esp. iOS)
    // allow playback with sound; without a click it's a muted autoplay.
    if (this.isMinimal()) {
      this.createMinimalPlayer({
        startWithSound: fromClick,
        autoplay: !fromClick && this.autoplay,
      });
      this.$overlay.fadeOut(300);
      return;
    }

    this.$overlay.fadeOut(300, async () => {
      if (window.VideoLoader) {
        try {
          const videoLoader = new VideoLoader();
          const player = await videoLoader.load(
            this.$videoContainer,
            this.videoUrl,
            this.autoplay,
            { playOnReady: true, ratio: this.aspectRatio, player: this.playerConfig }
          );
          this.$container.addClass("active");
          this.applyVolume(player);
        } catch (error) {
          console.error("Fehler beim Laden des Videos via VideoLoader:", error);
          this.$overlay.fadeIn(300);
          this.isPlaying = false;
        }
      } else {
        console.error("VideoLoader ist nicht verfügbar.");
        this.$overlay.fadeIn(300);
        this.isPlaying = false;
      }
    });
  }

  /**
   * Shows the player directly without overlay (overlay disabled or trusted host).
   * Unless autoplay is on, the stream only loads once the viewer presses play.
   */
  async initPlayerWithoutOverlay() {
    if (this.isMinimal()) {
      this.createMinimalPlayer({ autoplay: this.autoplay });
      return;
    }

    if (!window.VideoLoader) {
      console.error("VideoLoader ist nicht verfügbar.");
      return;
    }

    try {
      const videoLoader = new VideoLoader();
      const player = await videoLoader.load(
        this.$videoContainer,
        this.videoUrl,
        this.autoplay,
        {
          playOnReady: this.autoplay,
          poster: this.customThumbnail,
          ratio: this.aspectRatio,
          player: this.playerConfig,
          lazyLoad: !this.autoplay,
        }
      );
      this.$container.addClass("active");
      this.applyVolume(player);
    } catch (error) {
      console.error("Fehler beim Laden des Videos via VideoLoader:", error);
    }
  }

  /**
   * Whether this video uses the minimal (conversion-optimized) player instead of Plyr.
   */
  isMinimal() {
    return !!(this.playerConfig && this.playerConfig.style === 'minimal');
  }

  /**
   * @param {Object} options {autoplay, startWithSound} – see MinimalPlayer
   */
  createMinimalPlayer(options) {
    this.minimalPlayer = new MinimalPlayer(this.$videoContainer[0], Object.assign({
      url: this.videoUrl,
      poster: this.customThumbnail,
      volume: this.defaultVolume,
      config: this.playerConfig.minimal,
    }, options));
  }

  /**
   * Autoplay stays muted (browser policy); otherwise use the editor-chosen volume.
   */
  applyVolume(player) {
    if (this.autoplay) {
      player.muted = true;
    } else {
      player.muted = false;
      player.volume = this.defaultVolume;   // Plyr expects 0–1
    }
  }
}

jQuery(document).ready(function () {
  jQuery(".mad-video__container").each(function () {
    new MadVideo(jQuery(this));
  });
});
